import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import PageCommunityMenu from './PageCommunityMenu';

function CommunityMenu({ community, homes, plans, ...props }) {
  return (
    <PageCommunityMenu
      {...props}
      title="Community Menu"
      items={[
        {
          id: '#description',
          title: 'Community Description',
        },
        {
          id: '#photo',
          title: 'Photo Gallery',
          hide: !(get(community, 'photos', []).length > 0),
        },
        {
          id: '#homes',
          title: 'Available Homes',
          hide: !(homes.length > 0),
        },
        {
          id: '#plans',
          title: 'Home Plans',
          hide: !(plans.length > 0),
        },
        {
          id: '#site-plan',
          title: 'Site Plan',
          hide: !(get(community, 'zplatpublished')),
        },
        {
          id: '#features',
          title: 'Features',
          hide: !(get(community, 'features').length > 0),
        },
        {
          title: 'Request More Info',
          modal: true,
        },
      ]}
    />
  );
}

CommunityMenu.propTypes = {
  community: PropTypes.object.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default CommunityMenu;



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/CommunityMenu.js